export const IS_REQUIRED = 'required'
export const IS_EMAIL = 'isEmail'
export const IS_PHONE_NUMBER = 'matchRegexp:^[0-9]{9,11}$'
export const IS_PATIENT_ID = 'required';
